import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import * as Auth from "../helper/auth";

export const ProtectedRouter = () => {
  return Auth.checkLoginOrNot() === false ? (
    <Outlet />
  ) : (
    <Navigate to="/manage-QC" />
  );
};

export const ProtectedLoginRouter = () => {
  const location = useLocation();
  localStorage.setItem(
    "redirectAfterLogin",
    location.pathname + location.search
  );
  return Auth.checkLoginOrNot() === true ? <Outlet /> : <Navigate to="/" />;
};
